import type { SearchPanelGroup } from '@shared/ui';

import { PERMISSION_DOMAIN_LABEL_MAP } from '../config/permission-domain-label-map';
import { PERMISSION_RESOURCE_TO_DOMAIN_MAP } from '../config/permission-resource-to-domain-map';
import type { TenantPermission } from '../model/types';

const resourceToDomain = PERMISSION_RESOURCE_TO_DOMAIN_MAP as Record<string, string>;
const domainLabel = PERMISSION_DOMAIN_LABEL_MAP as Record<string, string>;

export const buildPermissionGroups = (
  permissions: TenantPermission[],
): SearchPanelGroup[] => {
  const byDomain = new Map<string, TenantPermission[]>();

  for (const permission of permissions) {
    const domain = resourceToDomain[permission.resource] ?? permission.resource;
    const bucket = byDomain.get(domain) ?? [];
    byDomain.set(domain, [...bucket, permission]);
  }

  return Array.from(byDomain, ([domain, items]) => ({
    id: domain,
    label: domainLabel[domain] ?? domain,
    items: items.map((item) => ({ id: item.name, label: item.name })),
  }));
};
